module.exports = __webpack_public_path__ + "static/media/canadian-maple-leaf.319d83c1.svg";